export default {
    lang: {
        name: 'Box Size'
    }
}
